import React from "react";
import {
  Alert,
  Snackbar,
  Typography,
  Box,
} from "@mui/material";
import { createRoot } from "react-dom/client";

export const clippingErrorAlert = ({
  documentName,
  error,
}) => {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = createRoot(container);

  const handleClose = () => {
    root.unmount();

    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };

  root.render(
    <Snackbar
      open
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity="error"
        variant="filled"
        sx={{
          width: "100%",
          minWidth: 350,
          alignItems: "flex-start",
        }}
      >
        <Box>
          <Typography fontWeight="bold">
            Error al generar clipping
          </Typography>

          <Typography variant="body2">
            Documento: {documentName}
          </Typography>

          <Typography variant="body2">
            Hora: {new Date().toLocaleTimeString()}
          </Typography>

          <Typography
            variant="caption"
            sx={{
              display: "block",
              mt: 1,
              opacity: 0.9,
            }}
          >
            {error}
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};
